<template>
  <div class="w-full bg-white height-100">
    <!-- <el-dialog class="ne-oppop" width="70%" :visible.sync="popupnew" center>
      <customNotification />
    </el-dialog> -->
    <el-dialog
      :visible.sync="centerDialogVisibletr"
      width="30%"
      center
      class="ishidePopup"
    >
      <div class="flex justify-center items-center">
        <div class="">
          <div class="mt-2">
            <p class="text-lg font-semibold mb-0 text-black">Phone Number</p>
            <el-input
              placeholder="Please input"
              maxlength="10"
              class="mt-1"
              v-model="input"
            ></el-input>
          </div>
          <div class="mt-2">
            <p class="text-lg font-semibold mb-0 text-black">Bot Name</p>
            <el-input
              placeholder="Please input"
              maxlength="50"
              class="mt-1"
              v-model="input"
            ></el-input>
          </div>
          <div class="mt-2">
            <p class="fsize12 col-4f">
              Our representative will call you for further setups in next 24-48
              hours
            </p>
          </div>

          <div class="flex gap-4 justify-center mt-4 items-center">
            <b-button
              class="bg-gtr border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
            >
              Submit
            </b-button>
            <b-button
              @click="isShowCampaignPopup = true"
              class="bgtyr border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 w-full sm-fsize14"
            >
              Cancel
            </b-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="30%"
      center
      class="hidedialog ishidePopup rounded-10px"
    >
      <div class="flex justify-center items-center">
        <div>
          <div class="flex justify-center">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
              class="w-32 h-32"
            />
          </div>
          <div class="text-center mt-4">
            <h4 class="font-semibold text-dark text-2xl">
              You Need more Notification Credits
            </h4>
            <p class="fsize12 text-black pt-1">
              The Campaign is set to target
              <span class="text-primary font-semibold"> 1000</span> audience.
              need <span class="text-primary font-semibold"> 100</span> more
              email credits to run this Campaign
            </p>
          </div>
          <div class="flex gap-4 justify-center mt-6 items-center">
            <vs-button
              type="success"
              class="bg-success rounded-full text-white font-medium fsize14 py-12px px-6"
              @click="handleClick('Add-ons')"
            >
              By more notification credits
            </vs-button>
            <vs-button
              type="primary"
              @click="centerDialogVisible = false"
              class="bg-primary rounded-full text-white font-medium fsize14 py-12px px-6"
            >
              Edit Target audience
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="isShowCampaignPopup"
      custom-class="ishidePopup"
      width="30%"
      center
    >
      <div class="">
        <div class="block">
          <div>
            <span class="demonstration text-dark font-semibold"
              >Pick a Date & Time</span
            >
          </div>
          <el-date-picker
            v-model="datepick"
            type="date"
            placeholder="Pick a date"
            class="mt-3 w-full"
          >
          </el-date-picker>
        </div>
        <p class="text-8f8f8f fsize12 mt-2">
          You can alwys change the schedule later by visting your planner before
          the event goes live.
        </p>

        <el-divider class="text-primary font-semibold">OR</el-divider>
        <div>
          <div class="flex items-center">
            <input type="checkbox" class="cust-check" />
            <p class="pl-2 mb-0 text-dark font-semibold">Start it Instantly</p>
          </div>
          <p class="text-8f8f8f fsize12 mt-1">
            Link a specific page or a website you'd like to inclide in your
            campaign
          </p>
        </div>

        <div class="flex gap-4 justify-center mt-6 items-center">
          <vs-button
            type="success"
            class="bg-success w-1/2 rounded-full text-white font-medium fsize14 py-12px px-6"
          >
            Confirm Campaign
          </vs-button>
          <vs-button
            type="secondary"
            class="bg-secondary w-1/2 rounded-full text-white font-medium fsize14 py-12px px-6"
          >
            Cancel
          </vs-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="isShowNewSegment" width="50%" center>
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize16 text-white">Add New Segment</h2>
      </div>
      <div>
        <AddSegmentTable @handleAddNewSegment="handleAddNewSegment" />
      </div>
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl font-semibold">
            Create a Push Notification
          </h2>
        </div>
      </div>
    </div>
    <div class="bg-white px-6 py-8 menucontrol-scroll fixed-top">
      <div class="flex w-full h-full">
        <div class="w-2/5 pr-12">
          <div class="relative text-center">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/marcom/campaignImage/Group 118.png"
              alt="sms"
              class="width-whatsapp mx-auto"
            />
            <div
              class="absolute top-18per left-0 mx-auto right-0 width-whatsapps flex justify-center items-start"
            >
              <div>
                <div class="text-center">
                  <h4 class="text-white font-medium fsize50">
                    {{ timeFormat }}
                  </h4>

                  <small class="text-white fsize16">{{ dateFormat }}</small>
                </div>

                <div class="mt-6 wid-mobiless">
                  <div
                    class="flex justify-between items-center bg-cbe3ec py-2 px-4 rounded-tlr-20px"
                  >
                    <div class="flex items-center">
                      <img
                        :src="
                          brandProfile.primaryLogo
                            ? `${this.$imageURL}` + brandProfile.primaryLogo
                            : ''
                        "
                        alt="logo"
                        class="w-8 h-8"
                      />
                      <p class="font-medium pl-2 mb-0 text-8f8f8f">
                        {{
                          selectedTemplate.projectName
                            ? selectedTemplate.projectName
                            : "Brained"
                        }}
                      </p>
                    </div>
                    <small class="text-8f8f8f fsize10">7m ago</small>
                  </div>

                  <div class="bg-8ec1d4 rounded-blr-20px text-left p-4">
                    <h4 class="text-black fsize14 mb-0">
                      {{
                        selectedTemplate.title
                          ? selectedTemplate.title
                          : "Get excited!"
                      }}
                    </h4>
                    <p class="mb-0 fsize12 text-black wordf">
                      {{
                        selectedTemplate.body
                          ? selectedTemplate.body
                          : "Your order is confirmed and is on its way!"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-3/5 bg-white relative">
          <div class="grid grid-cols-2 gap-8">
            <div>
              <div class="">
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  Give a title to this Campaign
                </h6>

                <el-input
                  placeholder="Please Add Campaign Title"
                  class="mt-3 w-full"
                  maxlength="50"
                  v-model="campaignTitle"
                ></el-input>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{
                    campaignTitle === "" || campaignTitle[0].trim() === ""
                      ? "This Field is required"
                      : ""
                  }}
                </p>
              </div>

              <div class="mt-6">
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  Select Template
                </h6>

                <el-select
                  filterable
                  v-model="notificationTemplate"
                  @change="selectedNotificationTemplate"
                  placeholder="Select Template"
                  class="w-full mt-2"
                >
                  <el-option
                    v-for="item in getAllNotificationTemplate"
                    :key="item._id"
                    :label="item.title"
                    :value="item._id"
                  >
                  </el-option>
                </el-select>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{
                    selectedTemplate.length === 0
                      ? "This Field is required"
                      : ""
                  }}
                </p>
                <el-divider>or</el-divider>
                <p
                  class="w-full mt-2 text-success flex items-center gap-2 cursor-pointer text-white font-semibold fsize14"
                  @click="handleSend('template-Pushnotification')"
                >
                  <!-- <p
                  @click="popupnew = true"
                  class="w-full mt-2 text-success flex items-center gap-2 cursor-pointer text-white font-semibold fsize14"
                > -->
                  <feather-icon
                    icon="PlusIcon"
                    svgClasses="w-5 h-5"
                    class="flex"
                  />Create New Template
                </p>
              </div>
            </div>
            <div>
              <div class="">
                <h6 class="col-4f text-xl mb-1 font-semibold">
                  Select Target Segment
                </h6>

                <el-select
                  multiple
                  filterable
                  v-model="segmentId"
                  placeholder=" Select Target Segment"
                  @change="getSegmentUsers"
                  class="w-full mt-2"
                >
                  <el-option
                    v-for="item in segmentData"
                    :key="item._id"
                    :label="item.name"
                    :value="item._id"
                  >
                  </el-option>
                </el-select>
              </div>
              <p v-if="submitted == true" class="fsize12 text-danger">
                {{ segmentId.length === 0 ? "This Field is required" : "" }}
              </p>
              <el-divider>or</el-divider>
              <div class="my-6">
                <div @click="isShowNewSegment = true" class="cursor-pointer">
                  <div class="flex items-center cursor-pointer gap-2">
                    <feather-icon
                      icon="PlusIcon"
                      svgClasses="w-5 h-5"
                      class="text-success flex"
                    />
                    <p class="text-success fsize14 my-0 font-semibold">
                      Create New Segment
                    </p>
                  </div>
                </div>
              </div>
              <div class="flex justify-between w-full mt-2">
                <div class="flex gap-2 items-center">
                  <p class="col-4f fsize12 font-medium">TG Size:</p>
                  <p class="text-primary fsize12 font-semibold">
                    {{ segmentId ? segmentId.length : 2000 }}
                  </p>
                </div>
                <div class="flex gap-2 items-center">
                  <p class="col-4f fsize12 font-medium">
                    Push Notification Credits:
                  </p>
                  <p class="text-primary fsize12 font-semibold">
                    {{ myAddonsData ? myAddonsData.quantity : 0 }}
                  </p>
                </div>
              </div>
              <div
                class="mt-6 bg-f4f5f6 p-4 rounded-6px"
                v-if="this.myAddonsData.quantity <= 100"
              >
                <h3 class="font-semibold col-4f text-xl">Resources</h3>
                <div class="flex items-center w-full mt-4">
                  <div class="flex gap-2 items-center w-full">
                    <img
                      src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/sms.svg"
                      class="object-contain"
                      alt="banh"
                    />

                    <div class="mt-2 pl-4">
                      <h2 class="font-semibold mb-0 col-4f text-lg">
                        x 100000 Push Notification Credits
                      </h2>
                      <p class="fsize12 mt-0 col-4f">
                        You have Push Notification
                      </p>
                    </div>
                  </div>
                </div>

                <div class="w-full mt-4">
                  <vs-button
                    color="success"
                    @click="handleClick('Add-ons')"
                    class="w-full bg-success border-0 text-white font-normal fsize14"
                  >
                    Buy More
                  </vs-button>
                </div>
              </div>
              <!-- <div class="mt-6">
                <h6 class="col-4f text-2xl mb-0">Pick a Template</h6>
                <p class="text-8f8f8f fsize12 mb-0">
                  Select a layout for your email
                </p>
                <div class="grid grid-cols-2 gap-4 mt-2">
                  <div>
                    <img
                      src="@/assets/images/frag.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag2.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag3.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag4.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="absolute bottom-0 right-0">
            <!-- <div @click="centerDialogVisible = true" class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class=""
                @click="handleClick('marcom-Whatsappcampaign-complete')"
              />
            </div> -->
            <div class="bg-primary w-24 h-24 rounded-full cursor-pointer">
              <div class="flex justify-center items-center w-24 h-24">
                <feather-icon
                  icon="ArrowRightIcon"
                  svgClasses="w-10 h-10"
                  class="text-white flex"
                  @click="pushNotification"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import VueEllipseProgress from "vue-ellipse-progress";
import AddSegmentTable from "../../../../segment/components/AddSegmentTable.vue";
import customNotification from "./custom-notification.vue";
import moment from "moment";
export default {
  data() {
    return {
      centerDialogVisible: false,
      centerDialogVisibletr: false,
      popupnew: false,
      textarea2: "",
      input: "",
      campaignTitle: "",
      segmentData: [],
      segmentId: [],
      userData: [],
      uniqueUserRecord: [],
      notificationTemplate: "",
      isShowCampaignPopup: false,
      isShowNewSegment: false,
      selectedTemplate: [],
      submitted: false,
      brand: "",
      myAddonsData: "",
    };
  },
  components: {
    AddSegmentTable,
    customNotification,
  },
  methods: {
    async getAllmyAddons() {
      let smsAddOns = {};
      for (let i of this.myAddOns) {
        if (i.addOnId.flag == "PN") {
          smsAddOns = i;
        }
      }
      this.myAddonsData = smsAddOns;
    },
    async getBrandProfile() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      let data = this.$store.dispatch("brandProfile/getBrandProfile", payload);
      this.brand = this.brandProfile;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },

    async getAllSegments() {
      try {
        let { data } = await this.$store.dispatch("segment/getAllSegment");
        this.segmentData = data.registeredUser;
        console.log(data);
      } catch (err) {
        console.log(err);
      }
    },

    async handleAddNewSegment() {
      this.isShowNewSegment = false;
      let { data } = await this.$store.dispatch("segment/getAllSegment");
      this.segmentData = data.registeredUser;
    },
    getSegmentUsers() {
      // console.log(this.segmentId);

      // console.log(this.segmentData);
      for (let i of this.segmentData) {
        for (let j of this.segmentId) {
          if (i._id == j) {
            console.log(i.audienceId);
            if (this.userData.length == 0) {
              this.userData.push(...i.audienceId);
            } else {
              for (let semp of i.audienceId) {
                if (!this.userData.includes(semp)) {
                  this.userData.push(semp);
                }
              }
            }
          }
        }
      }

      const key = "_id";
      const uniqueArray = [
        ...new Map(this.userData.map((x) => [x[key], x])).values(),
      ];
      this.uniqueUserRecord = uniqueArray;
      console.log(uniqueArray, "ytuyuty");
    },
    async pushNotification() {
      this.submitted = true;
      if (this.myAddonsData.quantity < this.segmentId.length) {
        this.centerDialogVisible = true;
      } else {
        if (
          this.campaignTitle !== "" &&
          this.selectedTemplate !== "" &&
          this.segmentId !== ""
        ) {
          let data = await this.$store.dispatch("billing/myAddOns");
          // console.log(this.myAddOns);
          // let smsAddOns = {};
          let addOns = this.myAddOns.filter((x) => {
            return x.addOnId.flag == "P_SMS";
          });
          // for (let i of this.myAddOns) {
          // if (addOns[0].addOnId.flag == "P_SMS") {
          //   smsAddOns = i.addOnId;
          // }
          // }
          // console.log(addOns);

          if (this.uniqueUserRecord.length > addOns[0].quantity) {
            this.centerDialogVisible = true;
          } else {
            // console.log(this.uniqueUserRecord);
            let temp = [];
            for (let i of this.uniqueUserRecord) {
              if (i.firebasetoken) {
                temp.push(i);
              }
            }
            // console.log(temp.length, "compane length");
            if (
              this.campaignTitle !== "" &&
              this.selectedTemplate !== "" &&
              this.segmentId !== ""
            ) {
              if (temp.length != 0) {
                await this.$swal
                  .fire({
                    title: `${temp.length} Users are Eligible`,
                  })
                  .then(async (result) => {
                    if (result.isConfirmed) {
                      // console.log("woooo");
                      const payload = {
                        audience: temp,
                        title: this.selectedTemplate.title,
                        message: this.selectedTemplate.body,
                        name: this.campaignTitle,
                        // projectName:
                      };
                      let data = await this.$store.dispatch(
                        "pushNotification/createPushNotification",
                        payload
                      );
                      console.log(data);
                      if (data.code == 200 && !data.data.code) {
                        const res = await this.$swal({
                          icon: "success",
                          title:
                            "Push Notification Campaign Created Successfully",
                          showConfirmButton: true,
                        });
                      } else {
                        this.$swal({
                          icon: "warning",
                          title: `Campaign Name Already Exists`,
                          showConfirmButton: true,
                        });
                      }
                    }
                  });
              } else {
                await this.$swal({
                  icon: "warning",
                  title: `${temp.length} eligible user Found`,
                  showConfirmButton: true,
                });
              }
            }
          }
          //   else{
          //     this.$swal({
          //         title: `All Fields are required`,
          //         // text: message,
          //         icon: "warning",
          //         confirmButtonColor: "#830c81",
          //         confirmButtonText: "OK",
          //       });
          //   }
          // }
        }
      }
    },
    handleSend(name) {
      this.$router.push({ name: name });
    },
    whitespaceRemove() {
      this.$el.addEventListener("input", () => {
        this.campaignTitle = this.campaignTitle
          ? this.campaignTitle.trimStart()
          : "";
      });
    },
    async selectedNotificationTemplate() {
      console.log(this.notificationTemplate);
      for (let i of this.getAllNotificationTemplate) {
        if (i._id == this.notificationTemplate) {
          this.selectedTemplate = i;
        }
      }
      console.log(this.selectedTemplate);
    },
  },
  async mounted() {
    this.getBrandProfile();
    this.getAllSegments();
    this.getAllmyAddons();
    // this.imagePreview();
    await this.$store.dispatch("pushNotification/getAllNotificationTemplate");
    console.log(this.getAllNotificationTemplate);
  },
  watch: {
    campaignTitle() {
      this.whitespaceRemove();
    },
  },
  computed: {
    ...mapState("brandProfile", ["brandProfile"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("admin", ["myAddOns"]),
    ...mapState("pushNotification", ["getAllNotificationTemplate"]),
    dateFormat() {
      return moment().format("dddd, MMMM DD");
    },
    timeFormat() {
      return moment().format("HH:mm ");
    },
  },
};
</script>
